import React from 'react';
import { withTranslation } from 'react-i18next';
import { SettingsContext } from './../components/context';

class CallExtension extends React.Component {
  static contextType = SettingsContext;
  constructor(props) {
    super(props);
    this.state = {
      callExtension: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    const setExtension = localStorage.getItem("callExtensionNumber");
    if(setExtension){
      this.setState({callExtension: setExtension});
    }
  }

  handleChange(e) {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({[name]: value});
  }

  handleBlur(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? (target.checked?1:0) : target.value;
    if(value){
      localStorage.setItem("callExtensionNumber", value);
    } else {
      localStorage.removeItem("callExtensionNumber");
    }

  }

  render() {
    const { t, className } = this.props;
    const { callExtension } = this.state;
    const { settings } = this.context;
    return (
      settings && settings.pbxType && settings.pbxType.value?
        <div className={className?className:''}>
          <input type="number" id="callExtension" className="font-weight-normal form-control dir-ltr w-75 mx-auto" onChange={this.handleChange} onBlur={this.handleBlur} value={callExtension} name="callExtension" placeholder="Extension Number"/>
        </div>
      :null
    )
  }
}

export default withTranslation()(CallExtension);